import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class DriveAttendanceService {
  constructor(private httpService: HttpService) {}

  async fetchAttendance(payload: any) {
    return await this.httpService.post('/attendance/fetch', payload);
  }

  async saveAttendance(payload: any) {
    return await this.httpService.post('/attendance/save', payload);
  }

  async fetchStudents(payload: any) {
    return await this.httpService.post('/attendance/list', payload);
  }

  async downloadData(payload: any) {
    return await this.httpService.post('/attendance/download', payload);
  }

  async revokeOrRestoreStudent(payload: any, type: string) {
    return await this.httpService.post(`/attendance/change/${type}`, payload);
  }
}
